import React from "react";
import { Table } from "antd";

const TabelaTurmas = ({
    className,
    loading,
    pagination,
    acesso,
    columns,
    dataSource,
    handleChangeTable,
    onRowClick,
    carregarSubRows,
    expandedRowRender
}) => {
    return (
        <Table
            id="cursos-disciplinas"
            className={className}
            loading={{
                spinning: loading,
                indicator: (
                    <div className="loading-data-table">
                        <div className="loading" />
                    </div>
                )
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={pagination}
            locale={{ emptyText: "Não existem dados!" }}
            onChange={handleChangeTable}
            rowClassName={acesso?.read ? "clickeble-row" : ""}
            onRow={record => ({
                onClick: acesso?.read ? () => onRowClick(record.nome, "", record.id, true, record.multisseriado) : () => {}
            })}
            onExpand={carregarSubRows}
            expandedRowRender={expandedRowRender}
        />
    );
};

export default TabelaTurmas;
